import { HisBaseGlobalsService } from './../../../core/service/base/his-base-globals.service';
import { HisDynamicFieldBase } from '../../model/field-base';
import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';

@Component( {
    template: `
        <his-plam [label]="options.label" [helptext]="options.helptext">
            <span #content class="plamContentText">{{value}}</span>
        </his-plam>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class LabelComponent extends HisDynamicFieldBase<string> implements OnInit {
    options: HisDynamicFieldConfig;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.options = injectedData.options;
    }

    ngOnInit() {
        super.initFormControl( null );
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ) {
    }

    getControlValue(): any {
        return null;
    }
}
